import { render, staticRenderFns } from "./DiagNotsupported.vue?vue&type=template&id=fb18a1f0&"
import script from "./DiagNotsupported.vue?vue&type=script&lang=js&"
export * from "./DiagNotsupported.vue?vue&type=script&lang=js&"
import style0 from "./DiagNotsupported.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports